module.exports = __webpack_public_path__ + "img/FILTER.849d38c2.svg";